<template>
    <div>
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-area type="fieldset">
                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            label="Data da receita"
                            :max-date="form.dataAtual"
                            v-model="model.medicamentoNaoPadronizado.dataReceita"
                            :validations="validations.dataReceita"
                        />
                    </rkm-col>

                    <rkm-col cols="9">
                        <rkm-form-input-autocomplete
                            :repository="repositories.usuario"
                            :requestQueryStringParams="{ with_not_regularized: true }"
                            :searchFields="fields.autocomplete.usuario"
                            :validations="validations.medicoSolicitante"
                            label="Médico solicitante"
                            text-field="cidadaoNome"
                            v-model="model.medicamentoNaoPadronizado.medicoSolicitante"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="8">
                        <rkm-form-input-autocomplete
                            :repository="repositories.cadastroMedicamentoNaoPadronizado"
                            :searchFields="fields.autocomplete.medicamentoNaoPadronizado"
                            :validations="validations.medicamento"
                            label="Medicamento"
                            text-field="descricao"
                            v-model="model.medicamentoNaoPadronizado.medicamento"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    @click="$refs.ModalCadastro.open(form.medicamentosNaoPadronizadosCadastrados)"
                                    color="primary"
                                    title="Cadastrar medicamento não padronizado"
                                >
                                    <rkm-icon icon="plus" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :validations="validations.quantidade"
                            label="Quantidade"
                            type="number"
                            v-model="model.medicamentoNaoPadronizado.quantidade"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0 text-nowrap">
                        <rkm-button
                            :label="false"
                            @click="save()"
                            color="primary"
                        >
                            <template v-if="model.medicamentoNaoPadronizado.id">
                                Salvar
                            </template>
                            <template v-else>
                                Incluir
                            </template>
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <ModalCadastro
            ref="ModalCadastro"
            @saveNaoPadronizados="saveNaoPadronizados"
        />

        <List
            :form="form"
            :model="model"
            @edit="edit($event)"
        />
    </div>
</template>

<script>
// Components
import List from './List'
import ModalCadastro from './cadastro/Modal'

// Mixins
import { repository, object, data } from '@/mixins'

//Moment
import moment from 'moment'

export default {
    components: { List, ModalCadastro },
    computed: {
        fields() {

            return {
                autocomplete: {
                    usuario: [{ key: "cadastro_cidadao.nome", searchable: true }],
                    medicamentoNaoPadronizado: [{ key: "descricao", searchable: true }],
                }
            }
        },
        validations() {

            return {
                dataReceita: { required: true },
                medicoSolicitante: { required: true },
                medicamento: { required: true },
                quantidade: { required: true, min: 1 },
            }
        }
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            cadastroMedicamentoNaoPadronizado: this.getConectaSusRepository('cadastro.medicamentoNaoPadronizado'),
        }

        this.modelDefault = this.clone(this.model.medicamentoNaoPadronizado)
    },
    data: () => ({
        modelDefault: null
    }),
    methods: {
        save() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    const medicamento = this.clone(this.model.medicamentoNaoPadronizado)

                    medicamento.dataReceita = this.getFormatedDate(medicamento.dataReceita, 'DD/MM/YYYY')
                    medicamento.save = true

                    if (medicamento.id) {

                        const idx = this.model.medicamentosNaoPadronizados.findIndex(m => m.id === medicamento.id)
                        Object.assign(this.model.medicamentosNaoPadronizados[idx], medicamento)

                    } else {

                        medicamento.id = `${new Date().getTime()}-medicamento-nao-padronizado`

                        this.model.medicamentosNaoPadronizados.push(medicamento)
                    }

                    this.model.medicamentoNaoPadronizado = this.modelDefault

                    this.$refs.RkmForm.resetValidator()
                })

        },
        edit(item) {

            const itemFind = this.clone(this.model.medicamentosNaoPadronizados.find(m => m.id === item.id))
            itemFind.dataReceita = moment(itemFind.dataReceita, 'DD/MM/YYYY').toDate()
            this.model.medicamentoNaoPadronizado = itemFind
        },
        saveNaoPadronizados(items) {

            this.form.medicamentosNaoPadronizadosCadastrados = items
        }
    },
    mixins: [repository, object, data],
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null }
    }
}
</script>

<style>

</style>